import {create} from 'zustand';
import {CarrouselIndexStore} from './types';

const useCarrouselIndexStore = create<CarrouselIndexStore>(set => ({
	carrouselIndex: 0,
	setCarrouselIndex: index => set({carrouselIndex: index}),
}));

export {useCarrouselIndexStore};
